/**
 * dialog.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
 */

import * as React from "react";
import {
  Dialog as MDDialog,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";

interface DialogProps {
  open: boolean,
  loading: boolean,
  title: string,
  classNames?: string,
  confirmText?: string,
  cancelText?: string,
  fullWidth?: boolean,
  disabledSuccess?: boolean,
  children: Array<React.ReactNode> | React.ReactNode,
  onClose(): void,
  onCancel?: () => void,
  onConfirm(): void,
  onMouseMove?(event: React.MouseEvent): void,
  onMouseUp?(event: React.MouseEvent): void
}

export function Dialog(props: DialogProps): React.ReactElement<any, any> {
  return <MDDialog
    className={props.classNames || ""}
    open={props.open}
    onClose={props.onClose}
    aria-labelledby="form-dialog-title"
    fullWidth={props.fullWidth}
    onMouseMove={props.onMouseMove}
    onMouseUp={props.onMouseUp}>
    <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
    <DialogContent>
      {props.children}
    </DialogContent>
    <DialogActions>
      <Button onClick={props.onCancel || props.onClose}
        disableRipple disableTouchRipple
        color="secondary" variant="contained" disabled={props.loading}>
        {props.cancelText || "Cancel"}
      </Button>
      {props.loading && <CircularProgress size={24} />}
      <Button onClick={props.onConfirm}
        disableRipple disableTouchRipple
        color="primary" variant="contained" disabled={props.loading || props.disabledSuccess}>
        {props.confirmText || "Confirm"}
      </Button>
    </DialogActions>
  </MDDialog>;
}
